import Vue from 'vue'

const UNIT_SET_NAME =(state, payload)=> {
            
    state.data.name = payload
};


const UNIT_SET_DUPLICATE =(state, payload)=> {
            
    state.data.duplicate = payload
};

const UNIT_SET_UNITS =(state, payload)=> {  
    
    state.units=payload
    
};

const UNIT_SET_UNIT =(state, payload)=> {       
    
    state.data.name = payload.name
        
};

const UNIT_INIT_UNIT =(state, payload)=> {       
    state.data.name = ''    
    
};



export default {
    UNIT_SET_NAME,
    UNIT_SET_DUPLICATE,
    UNIT_SET_UNITS,
    UNIT_SET_UNIT,
    UNIT_INIT_UNIT,
};